import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../../services/api';
import { LOGO_WPP } from '../../assets/images';
import StepBar from '../../components/StepBar/StepBar';
import Loader from '../../components/Loader/Loader';

import styles from './Simulacao.module.css';

const VIEW = { DEFAULT: 'default', WAIT: 'wait' };

export default function Simulacao() {
  const nomeUsuario = sessionStorage.getItem('nomeUsuario') || '';
  const firstName   = nomeUsuario.split(' ')[0];

  const [view,       setView]       = useState(VIEW.DEFAULT);
  const [wppLoading, setWppLoading] = useState(false);

  async function handleWpp() {

    //setView(VIEW.WAIT); //
    //return;             // TESTE — para forçar o template

    if (wppLoading) return;
    setWppLoading(true);

    const tel    = sessionStorage.getItem('payload_phone') || '';
    const numero = tel.startsWith('55') ? tel : `55${tel}`;

    try {
      const { data } = await api.get('/luz/api/raffle/', {
        params: { telefone: numero, produto: 'LUZ' },
      });

      const status = (data.status || '').trim();

      if (status === 'template_enviado') {
        setView(VIEW.WAIT);
        setWppLoading(false);
        return;
      }

      const msg  = encodeURIComponent(data.mensagem || 'Oi vim do #formLuz, quero mais informações!');
      const link = `https://api.whatsapp.com/send?phone=${data.numero}&text=${msg}`;
      window.location.href = link;
      // mantém o loader visível até o navegador sair da página — sem tela intermediária
    } catch {
      const msg  = encodeURIComponent('Olá, vim do #FORMLUZ, gostaria de continuar o atendimento...');
      const link = `https://api.whatsapp.com/send?phone=5519971349628&text=${msg}`;
      window.location.href = link;
    }
  }

  return (
      <>
        {wppLoading && <Loader text="Conectando com um especialista..." />}

        <div className={styles.wrap}>
          <StepBar current={3} />

          {/* ── VIEW: DEFAULT ── */}
          {view === VIEW.DEFAULT && (
              <div className={styles.body}>
                <div className={styles.checkWrap}>
                  <div className={styles.checkCircle}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M7 12.5l3.5 3.5 6.5-7"
                            stroke="#16a34a" strokeWidth="2.5"
                            strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                </div>

                <h1 className={styles.title}>
                  {firstName ? `${firstName}, sua` : 'Sua'} triagem foi concluída!
                </h1>

                <p className={styles.sub}>
                  Agora é só enviar sua <strong>conta de energia atualizada</strong> e
                  confirmar algumas informações com nosso especialista via WhatsApp.
                </p>

                <button className={styles.btnWpp} onClick={handleWpp} disabled={wppLoading}>
                  <img src={LOGO_WPP} alt="" aria-hidden="true" />
                  Continuar no WhatsApp
                </button>

                <Horario />
              </div>
          )}

          {/* ── VIEW: WAIT ── */}
          {view === VIEW.WAIT && (
              <div className={styles.body}>
                <div className={styles.waitEmoji}>📲</div>
                <h2 className={styles.waitTitle}>Tudo certo por aqui!</h2>
                <p className={styles.waitText}>
                  Agora é só aguardar nosso contato.<br />
                  Um dos nossos especialistas vai te chamar no <strong>WhatsApp</strong> em breve para continuar o atendimento.
                </p>
                <p className={styles.waitHighlight}>
                  🔔 Fique de olho no WhatsApp — em alguns instantes você receberá nossas orientações por lá!
                </p>
                <Horario />
              </div>
          )}

        </div>
      </>
  );
}

function Horario() {
  return (
      <div className={styles.horario}>

      </div>
  );
}